/**
 * eventBus — pub/sub liviano basado en `window` para comunicar cambios entre
 * componentes que no comparten árbol (p. ej. Layout ↔ SalesOrdersQueue).
 *
 * Uso:
 *   import bus from "@/lib/eventBus";
 *   bus.emit("orders:refresh");
 *   const off = bus.on("orders:refresh", () => refetch());
 *   // cleanup
 *   off();
 */

const emit = (name, detail = null) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
};

const on = (name, handler) => {
  if (typeof window === "undefined") return () => {};
  const wrapped = (e) => handler(e.detail);
  window.addEventListener(name, wrapped);
  return () => window.removeEventListener(name, wrapped);
};

export default { emit, on };
